export default __webpack_public_path__ + "static/media/bubble-3.2c5ed7df.png";